// extracted by mini-css-extract-plugin
export default {"inputContainer":"_35drR","icon":"_24JkK","selectedText":"CIABy","text":"_22paN"};